import { render, staticRenderFns } from "./ConfigureUpsell.vue?vue&type=template&id=12fc7ace&scoped=true"
import script from "./ConfigureUpsell.vue?vue&type=script&lang=js"
export * from "./ConfigureUpsell.vue?vue&type=script&lang=js"
import style0 from "./ConfigureUpsell.vue?vue&type=style&index=0&id=12fc7ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fc7ace",
  null
  
)

export default component.exports